import {
  AmenitiesFilm,
  FloorPlanCompare,
  MeetingFloorPlan,
  MeetingRoom,
  ModelGallery,
  AmenitiesDisplay,
  AmenitiesModel,
  AmenitiesModelFloors,
  Landing,
  AmenitiesGallery,
  GreatRoom,
  PrivateShowing
} from "pages";
import userRouteMap from "./userRouteMap";

export default function route() {
  return [
    {
      path: userRouteMap.LANDING.path,
      name: "categories",
      element: <Landing />,
    },
    {
      path: userRouteMap.MEETINGFLOORPLAN.path,
      name: "floor-plan",
      element: <MeetingFloorPlan />,
    },
    {
      path: userRouteMap.FLOORPLANCOMPARE.path,
      name: "floor-plan-compare",
      element: <FloorPlanCompare />,
    },
    {
      path: userRouteMap.MODELGALLERY.path,
      name: "model-gallery",
      element: <ModelGallery />,
    },
    {
      path: userRouteMap.AMENITIES_FILM.path,
      name: "amenities-film",
      element: <AmenitiesFilm />,
    },
    {
      path: userRouteMap.GALLERY.path,
      name: "amenities-gallery",
      element: <AmenitiesGallery />,
    },
    {
      path: userRouteMap.MEETINGROOM.path,
      name: "meeting-room",
      element: <MeetingRoom />,
    },

    {
      path: userRouteMap.PRIVATESHOWING.path,
      name: "private-showing",
      element: <PrivateShowing />,
    },

    {
      path: `${userRouteMap.AMENITIESDISPLAY.path}`,
      name: "amenities-display",
      element: <AmenitiesDisplay />,
    },
    {
      path: userRouteMap.AMENITIESMODEL.path,
      name: "amenities-model",
      element: <AmenitiesModel />,
    },
    {
      path: userRouteMap.AMENITIES_MODEL_FLOORS.path,
      name: "amenities-model-floors",
      element: <AmenitiesModelFloors />,
    },
    {
      path: userRouteMap.GREATROOM.path,
      name: "great-room",
      element: <GreatRoom />,
    },
    {
      path: userRouteMap.LOUNGEROOM.path,
      name: "lounge-room",
      element: <MeetingRoom />,
    },
  ];
}
